import React from "react";
import { Outlet } from "react-router-dom";

import { ScannerProvider } from "./ScannerContext";

const ScannerContextLayout = () => {
  return (
    <ScannerProvider>
      <Outlet />
    </ScannerProvider>
  );
};

export default ScannerContextLayout;
